// extracted by mini-css-extract-plugin
export default {"userName":"FNj5EINX49OAoijQQVZe"};